import store from '../../store';

export default (redirect) =>
  new Promise((resolve) => {
    console.log('logout');

    store.dispatch('auth/logout');

    if (redirect) {
      window.router.push({
        name: redirect,
      });
    }
    resolve(true);
  });
